var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStampIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.059,
    height: 25.098,
    viewBox: "0 0 22.059 25.098",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_6190",
    "data-name": "Group 6190",
    transform: "translate(-31)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_47480",
    "data-name": "Path 47480",
    d: "M32.471,22.892v1.471a.736.736,0,0,0,.735.735H50.853a.736.736,0,0,0,.735-.735V22.892ZM45.777,8.676a5.149,5.149,0,1,0-7.494,0,4.736,4.736,0,0,1,1.151,2.581A4.877,4.877,0,0,1,38.6,14.8h6.855a4.879,4.879,0,0,1-.832-3.547,4.736,4.736,0,0,1,1.151-2.581Zm6.547,12.746H31.735A.735.735,0,0,1,31,20.686v-.735a3.681,3.681,0,0,1,3.676-3.676H49.382a3.681,3.681,0,0,1,3.676,3.676v.735A.735.735,0,0,1,52.324,21.422Z",
    fill: "#1c212d"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStampIcon);
export default __webpack_public_path__ + "static/media/stampIcon.ee1f6a4f6722d97b851d03312f21d762.svg";
export { ForwardRef as ReactComponent };